// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__njvsN","normalXl":"styles_normalXl__hv1au","normalLg":"styles_normalLg__2QxoN","normalMd":"styles_normalMd__URBp-","normalSm":"styles_normalSm__pls-U"};